import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/widgets";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { ParkingSquare, MapPin, Navigation, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Parking() {
  const [spots, setSpots] = useState(null);
  useEffect(() => { api.get("/parking").then((r) => setSpots(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="parking-page">
      <PageHeader title="Parking Finder" subtitle="Safe parking near you." icon={ParkingSquare} />

      <div className="relative overflow-hidden rounded-3xl border border-zinc-200 bg-gradient-to-br from-emerald-50 to-zinc-50 p-8 text-center">
        <MapPin className="mx-auto text-emerald-500" size={32} />
        <p className="mt-2 text-sm font-medium text-zinc-700">Lagos • Live map coming soon</p>
        <p className="text-xs text-zinc-400">Real-time parking provider integration ready.</p>
      </div>

      {!spots ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <Skeleton key={i} className="h-24 rounded-3xl" />)}</div>
      ) : (
        <div className="space-y-3">
          {spots.map((s) => (
            <div key={s.id} className="rounded-3xl border border-zinc-200 bg-white p-5" data-testid="parking-item">
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-display font-semibold text-zinc-900">{s.name}</div>
                  <div className="mt-1 flex items-center gap-3 text-xs text-zinc-400">
                    <span className="flex items-center gap-1"><Navigation size={12} /> {s.distance_km} km</span>
                    <span className="flex items-center gap-1"><Clock size={12} /> {s.status}</span>
                  </div>
                </div>
                <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.status === "Open" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>{s.spaces} spaces</span>
              </div>
              <div className="mt-4 flex items-center justify-between">
                <span className="font-display text-lg font-bold text-emerald-600">{s.price}</span>
                <Button size="sm" data-testid="parking-directions" onClick={() => toast.info("Opening directions…")} className="rounded-full bg-zinc-900 hover:bg-zinc-800 gap-1.5"><Navigation size={14} /> Directions</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
